import { FieldPath, FieldValues, get, useController } from 'react-hook-form';
import { FormTextAreaProps, FormTextArea } from '@britishcouncil/react-admin';

import { RHFormFieldProps } from './types';
import { useFormContext } from './FormContext';
import { ReadonlyFormValue } from './ReadonlyFormValue';

type RHFormTextareaProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = RHFormFieldProps<FormTextAreaProps<string>, TFieldValues, TName>;

export const RHFormTextarea = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  rules,
  shouldUnregister,
  defaultValue,
  ...props
}: RHFormTextareaProps<TFieldValues, TName>) => {
  const { mode } = useFormContext();

  const { field, formState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });

  if (mode === 'read') {
    return <ReadonlyFormValue label={props.label} value={field.value} textarea={props.rows != 1} />;
  }

  return (
    <FormTextArea
      {...props}
      value={field.value ?? ''}
      name={field.name}
      onBlur={field.onBlur}
      onChange={field.onChange}
      touched
      error={get(formState.errors, field.name)?.message}
    />
  );
};
